export const TRANSLATIONS = {
  ru: {
    smallSubscriptionBlock: {
      asset: (assetQuantity: number) =>
        `asset${assetQuantity === 1 ? "" : "s"}`,
    },
    chooseSubscription: {
      heading: "Выберите свой план подписки",
      subheading:
        "Оставьте рыночный анализ нам, чтобы принимать обоснованные решения.",

      yearly: "Ежегодно",
      monthly: "Ежемесячно",
      pay: "Перейти к оплате",
      block: {
        info: (assetQuantity: number) =>
          `Live-статистика для ${assetQuantity} актив${
            assetQuantity !== 1 ? "ов" : "а"
          } по вашему выбору. Оплата производится ежемесячно.`,
      },
      apply: "Применить",
      applyLoading: "Загрузка...",
      promocode: "Есть промокод?",
      info: "Промокод дает скидку только на первый платеж.",
    },
    landing: {
      hero: {
        heading1: "Принимайте более умные торговые решения с",
        heading2: "Глубокой рыночной аналитикой",
        subheading:
          "Перестаньте гадать направление рынка. Получайте реальные рыночные инсайты для 14 основных активов в реальном времени и торгуйте уверенно.",
        freeStart: "Начать бесплатно",
        noCard: "Без кредитной карты",
        socialProof: "Нам доверяют более 1 500 трейдеров по всему миру",
        cta: "Получить бесплатный доступ сейчас",
        ctaSecondary: "Смотреть 2-минутное демо",
      },
      trust: {
        heading: "Почему трейдеры доверяют MarketEcho",
        metric1Value: "99.9%",
        metric1Label: "Время работы",
        metric2Value: "1 500+",
        metric2Label: "Активные трейдеры",
        metric3Value: "14",
        metric3Label: "Поддерживаемые активы",
        metric4Value: "24/5",
        metric4Label: "Обновления в реальном времени",
        metric5Value: "1M+",
        metric5Label: "Ежедневных точек данных",
      },
      testimonials: {
        heading: "Что говорят трейдеры",
        testimonial1: {
          quote:
            "Вероятностные инсайты MarketEcho полностью изменили мою торговую стратегию. Прогнозы типов дней невероятно точны.",
          author: "Michael Chen",
          role: "Профессиональный Forex трейдер",
          period: "5 лет опыта",
        },
        testimonial2: {
          quote:
            "Наконец платформа, которая дает необходимые данные без лишней сложности. Метрики сессий сами по себе стоят подписки.",
          author: "Sarah Rodriguez",
          role: "Дейтрейдер",
          period: "3 года опыта",
        },
        testimonial3: {
          quote:
            "Сначала я скептически относился, но бесплатный план меня убедил. Сейчас я на плане с 5 активами, и мой процент выигрышей значительно вырос.",
          author: "James Davidson",
          role: "Свинг-трейдер",
          period: "7 лет опыта",
        },
        testimonial4: {
          quote:
            "Аналитика тайминга сессий изменила мою стратегию London breakout. Теперь я точно знаю, когда входить в позиции.",
          author: "Emma Thompson",
          role: "Скальпер и дейтрейдер",
          period: "4 года опыта",
        },
        testimonial5: {
          quote:
            "Как трейдер на полную занятость, точные вероятностные данные крайне важны. MarketEcho дает мне преимущество для стабильной прибыли каждый месяц.",
          author: "Robert Martinez",
          role: "Профессиональный дейтрейдер",
          period: "10+ лет опыта",
        },
      },
      finalize: {
        heading: "Оплата успешна!",
        info: `Пожалуйста, скачайте наш десктоп-приложение, чтобы подтвердить подписку, выбрать нужные активы и начать исследовать MarketEcho.`,
      },
      header: {
        home: "Home",
        features: "Функции",
        metrix: "Метрики",
        download: "Скачать",
        pricing: "Тарифы",
        signUp: "Получить бесплатный доступ",
        targetAudience: "Для дейтрейдеров и активных инвесторов",
      },
      howItWorks: {
        heading: "Начните заключать лучшие сделки за 3 простых шага",
        title1: "Зарегистрируйтесь бесплатно за 60 секунд",
        description1: `Без кредитной карты и скрытых платежей. Введите свой email и мгновенно получите доступ к реальным рыночным данным в реальном времени для 3 основных активов. Начните видеть, какие торговые стратегии работают лучше всего — прямо сейчас.`,
        button1: "Получить мгновенный бесплатный доступ",
        stepText1: "100% бесплатно навсегда",
        title2: "Выберите свой план (доступен бесплатный вариант навсегда)",
        description2: `Понравился бесплатный план? Оставляйте его навсегда. Готовы к большему? Повышайте уровень подписки и отслеживайте до 14 активов с расширенными моделями Live-данных. Отмена в любой момент без вопросов.`,
        button2: "Посмотреть все планы и тарифы",
        stepText2: "Гибкие планы — контроль в ваших руках",
        title3: "Торгуйте уверенно с аналитикой на основе данных",
        description3:
          "Перестаньте сомневаться в своих сделках. Получайте прогнозы на основе исторических данных, аналитику сессий и прогнозы типов дней, на которые опираются профессиональные трейдеры для максимизации прибыли.",
        button3: "Начать торговать умнее сегодня",
        stepText3: "Присоединяйтесь к 1 500+ активных трейдеров",
      },
      features: {
        heading: "Все, что нужно для профессиональной торговли",
        subheading:
          "Создано для трейдеров, которые ценят точность, скорость и практические инсайты",
        autonomous1: "Не пропускайте ни одной возможности",
        autonomous2: "Скоро появится десктоп-приложение",
        autonomousDesc:
          "Получайте мгновенные уведомления и запускайте аналитику 24/7 — даже когда вы не за своим столом.",
        optimized1: "Принимайте уверенные решения",
        optimized2: "Каждый день",
        optimizedDesc:
          "Наш мощный Big Data движок анализирует миллионы данных ежедневно, чтобы предоставлять наиболее точные рыночные вероятности на сегодня.",
        pairScreener: "Находите лучшие торговые возможности",
        pairScreenerDesc:
          "Мгновенно сканируйте все 14 активов, чтобы узнать, на каких рынках сейчас наивысшие вероятностные сценарии.",
        notifications: "Будьте на шаг впереди рынка",
        notificationsDesc:
          "Получайте уведомления в реальном времени, когда появляются высоковероятные торговые сигналы — больше не пропускайте выигрышные сделки.",
        assetsSupport: "Торгуйте любимыми рынками",
        assetsSupportDesc:
          "Forex, индексы, товары и криптовалюта. Все основные активы в одной мощной платформе.",
        multifunctionalDashboard: "Все в одном месте",
        multifunctionalDashboardDesc:
          "Доступ ко всем торговым данным, аналитике и инсайтам с одной интуитивной панели.",
        liveFeedStatistics: "Торговля в реальном времени",
        liveFeedStatisticsDesc:
          "Получайте обновления вероятностей в режиме Live, которые адаптируются к изменениям рынка в течение дня.",
        detailedDashboard: "Понимайте каждый рыночный шаг",
        detailedDashboardDesc:
          "Глубокий анализ сессий, типов дней и вероятностных сценариев для более умной торговли.",
      },
      plates: {
        plate1: {
          heading: "Прогнозы типов дней",
          text1: `Узнавайте заранее, какой тип торгового дня ожидать с помощью вероятностных прогнозов. Мы выделили более 10 уникальных ситуаций дней.`,
          text2: `Больше не нужно гадать между Trend Days и Reversal Days — видьте точную вероятность каждого сценария.`,
          text3: `Наша глубокая аналитика рассчитывает вероятность каждого типа дня в процентах, чтобы вы могли планировать свою стратегию.`,
          text4: `Кроме того, получайте мгновенные уведомления, когда уровни максимумов (PDH) и минимумов (PDL) предыдущего дня вот-вот будут пробиты.`,
          tooltip:
            "Типы дней помогают понять поведение рынка и выбрать правильную торговую стратегию для текущих условий.",
        },
        plate2: {
          heading: "Аналитика сессий",
          text1: `Определяйте оптимальное время для входа и выхода во время Азиатской, Лондонской и Нью-Йоркской сессий.`,
          text2: `Получайте вероятностные прогнозы, когда каждая сессия вероятно достигнет своего максимума или минимума.`,
          text3: `Отслеживайте направление сессии, зоны расширения и потенциал пробоя — чтобы точно знать, когда торговать, а когда ждать.`,
          tooltip:
            "Аналитика сессий показывает, какие торговые часы предлагают лучшие возможности на основе исторических вероятностных данных.",
        },
        plate3: {
          heading: "Ежедневные прогнозы движения",
          text1: `Смотрите, когда рынок наиболее вероятно достигнет дневного максимума или минимума на основе тысяч исторических ситуаций.`,
          text2: `Отслеживайте расширение цены в реальном времени, направление движения и потенциальные точки разворота в течение торгового дня.`,
          tooltip:
            "Ежедневные прогнозы помогают предвидеть ключевые ценовые движения заранее, давая вам существенное преимущество.",
        },
        plate4: {
          heading: "Метрики Initial Balance (IB)",
          text1: `Доступ к вероятностным данным для первого часа торговли — периода Initial Balance, который часто задает тон на весь день.`,
          text2: `Получайте прогнозы пробоев IB, зон расширения и вероятности продолжения импульса или разворотов.`,
          tooltip:
            "Initial Balance — это первый час торговли. Профессиональные трейдеры используют данные IB для прогнозирования дневного диапазона и направления.",
        },
        plate5: {
          heading: "Продвинутая аналитика сессий",
          text1: `Более глубокий анализ Regular Trading Hours (RTH), Time Price Opportunity (TPO) и Opening Range Breakout (ORB).`,
          text2: `Смотрите вероятности расширения RTH, распределения профиля и двусторонние сценарии пробоя для повышения своей торговли.`,
          tooltip:
            "Эти продвинутые метрики используют профессиональные трейдеры для определения высоковероятных торговых сигналов и эффективного управления рисками.",
        },
      },
      demo: {
        heading: "Посмотрите MarketEcho в действии",
        subheading1:
          "Посмотрите 2-минутное демо, чтобы увидеть, как профессиональные трейдеры используют MarketEcho для ",
        subheading2: "повышения процента успешных сделок и уверенной торговли",
        cta: "Начать бесплатный пробный период после просмотра",
      },
      download: `Доступ к MarketEcho через веб. Десктоп-приложение в разработке; как только оно будет доступно, обеспечит еще более быструю работу и дополнительные функции для профессиональной торговли.`,
      downloadCta: "Скачать для десктопа",
      downloadComingSoon: "Десктоп-приложение скоро появится",
      plans: {
        heading: "Выберите план, который соответствует вашему стилю торговли",
        subheading: `Начните 100% бесплатно и навсегда. Кредитная карта не нужна. Повышайте уровень подписки только когда готовы открыть больше рынков и продвинутые функции.`,
        action:
          "Все PRO-планы включают модели Live-данных, продвинутую аналитику и приоритетную поддержку.",
        riskFree: "Гарантия без риска",
        riskFreeDesc:
          "Отмена в любой момент. Без вопросов. Без скрытых платежей.",
        savingsAnnual: "Экономия 20% при ежегодной оплате",
        perDay: "в день",
        monthly: "ежемесячно",
        annually: "ежегодно",
        savePercent: "Экономия 20%",
        mostPopular: "Самый популярный",
        bestValue: "Наиболее выгодный",
        button: (assetQuantity: number) =>
          `Начать с ${assetQuantity} актив${
            assetQuantity !== 1 ? "ов" : "а"
          } сейчас`,
        value1Asset: "Меньше, чем чашка кофе в день",
        value5Assets: "Всего $1.83 за актив в день",
        value14Assets: "Всего $0.24 за актив в день",
        free: {
          forever: "БЕСПЛАТНО НАВСЕГДА",
          heading: "MarketEcho Basic",
          li1: "Отслеживание 3 активов",
          li2: "Базовая аналитика",
          li3: "Статическая модель данных (обновление ежедневно)",
          li4: "Без кредитной карты",
          start: "Начать бесплатно",
        },
        pro1: {
          badge: "PRO",
          li1: "1 актив с полным доступом к данным",
          li2: "Продвинутая аналитика",
          li3: "Live-обновления вероятностей",
          li4: "Приоритетная поддержка email & чат",
          li5: "Все будущие обновления включены",
        },
        pro5: {
          badge: "САМЫЙ ПОПУЛЯРНЫЙ",
          li1: "5 активов с полным доступом к данным",
          li2: "Продвинутая аналитика",
          li3: "Live-обновления вероятностей",
          li4: "Приоритетная поддержка email & чат",
          li5: "Все будущие обновления включены",
          li6: "Идеально для активных трейдеров",
        },
        pro14: {
          badge: "НАИБОЛЕЕ ВЫГОДНО",
          li1: "Все 14 активов с полным доступом к данным",
          li2: "Продвинутая аналитика",
          li3: "Live-обновления вероятностей",
          li4: "Приоритетная поддержка email & чат",
          li5: "Все будущие обновления включены",
          li6: "Идеально для профессиональных трейдеров",
        },
      },
      faq: {
        or: "ИЛИ",
        heading: "Часто задаваемые вопросы",
        subheading: `Есть вопросы? У нас есть ответы. Если нужна дополнительная помощь, наша служба поддержки доступна 24/7.`,
        contactHeading: "Остались вопросы? Свяжитесь с нами!",
        contactSubheading:
          "Наша команда обычно отвечает в течение 2 часов в рабочее время",
        subjectLabel: "Тема",
        subjectPlaceholder: "Чем можем помочь?",
        messageLabel: "Сообщение",
        messagePlaceholder: "Расскажите подробнее о вашем вопросе...",
        sendMessage: "Отправить email",
        contactTelegram: "Свяжитесь с нами в Telegram",
        question1:
          "Что означает 'Live-данные' и чем они лучше статических данных?",
        answer1: `Live-данные обновляются несколько раз в течение торгового дня в зависимости от рыночной ситуации, предоставляя наиболее точные вероятности именно тогда, когда они нужны. Статические данные обновляются один раз в день и подходят для свинг-трейдеров и планирования позиций. Live-данные — ваш ассистент в реальном времени, который адаптируется к рынку, чтобы вы никогда не принимали решения на основе устаревшей информации. Все платные планы включают Live-данные для максимальной точности.`,
        question2: `Какие рынки и активы можно торговать с MarketEcho?`,
        answer2: `Мы поддерживаем все основные торговые рынки: валютные пары (EURUSD, GBPUSD, USDJPY, USDCHF, USDCAD, EURJPY), фондовые индексы (NAS100, SPX500, DJ30, RTY, GER40), товары (Gold/XAUUSD, Oil/CL) и Индекс Доллара (DXY). Бесплатные пользователи могут отслеживать 3 актива: EURUSD, GER40 и XAUUSD. Платные планы открывают полную версию данных для 1–14 активов в зависимости от вашей подписки. Мы постоянно добавляем новые активы по запросам трейдеров.`,
        question3: `Бесплатный план действительно бесплатный навсегда? Есть подвох?`,
        answer3: `Да, 100% бесплатно навсегда. Без кредитной карты. Без пробных периодов. Никаких скрытых платежей. Вы получаете 3 актива, базовую аналитику и ежедневные обновления данных навсегда. Мы верим, что улучшение подписки должно быть осознанным выбором, а не навязанным. Попробуйте бесплатный план, оцените результат и повышайте подписку только когда готовы к большему. Более 1 500 трейдеров нам доверяют — многие начали с бесплатного плана.`,
        question4: `Сколько стоит MarketEcho и можно ли отменить подписку в любой момент?`,
        answer4: `Планы начинаются всего от $29.99/месяц (менее $1/день) за 1 актив с Live-данными. Наш самый популярный план — 5 активов за $54.99/месяц. Профессиональные трейдеры выбирают план на 14 активов за $99.99/месяц — всего $0.24 за актив в день. Все планы включают продвинутую аналитику, Live-данные и приоритетную поддержку. Отмена в любой момент без лишних хлопот — никаких долгосрочных обязательств и вопросов.`,
        question5: `Можно ли использовать MarketEcho на мобильном или нужен десктоп?`,
        answer5: `Вы можете получить доступ к MarketEcho через любой веб-браузер на компьютере прямо сейчас. Мы разрабатываем десктоп-приложения для еще более быстрой работы и дополнительных функций. Мобильные приложения также планируются. Вы получите уведомление, как только они станут доступны.`,
        question6: `Безопасна ли моя платежная информация? Как обрабатываются платежи?`,
        answer6: `Абсолютно безопасно. Мы принимаем криптоплатежи (TRC20, любые криптоактивы) и банковские переводы. Мы никогда не храним ваши платежные данные на наших серверах. Все транзакции обрабатываются через зашифрованные, безопасные каналы. Конфиденциальность и безопасность ваших данных — наш главный приоритет.`,
        question7: `Что если MarketEcho не подходит для моего стиля торговли?`,
        answer7: `Начните с бесплатного плана, чтобы протестировать без риска. Если вы повысите уровень подписки и решите, что он не для вас, просто отмените — без штрафов и вопросов. Мы уверены, что вы увидите ценность уже через несколько дней использования наших вероятностных прогнозов. Присоединяйтесь к 1 500+ трейдеров, которые повысили свои успехи с MarketEcho.`,
        question8: `Насколько точны ваши прогнозы и вероятностные оценки?`,
        answer8: `Наш мощный Big Data движок анализирует миллионы исторических данных для генерации вероятностей на основе глубокого анализа рыночных ситуаций. Мы не предсказываем будущее — мы показываем, что наиболее вероятно произойдет на основе тысяч похожих рыночных сценариев. Профессиональные трейдеры используют эти вероятности для обоснованных решений, а не для угадываний. Убедитесь сами с бесплатным планом.`,
      },
      footer: {
        privacy: "Политика конфиденциальности",
        terms: "Условия использования",
        disclaimer: "Отказ от ответственности",
        cookie: "Политика cookie",
        discord: "Присоединяйтесь к нам в Discord",
      },
    },
  },
  ua: {
    smallSubscriptionBlock: {
      asset: (assetQuantity: number) =>
        `asset${assetQuantity === 1 ? "" : "s"}`,
    },
    chooseSubscription: {
      heading: "Оберіть свій план підписки",
      subheading:
        "Залиште ринковий аналіз нам, щоб приймати обґрунтовані рішення.",

      yearly: "Щорічно",
      monthly: "Щомісяця",
      pay: "Перейти до оплати",
      block: {
        info: (assetQuantity: number) =>
          `Live-статистика для ${assetQuantity} актив${
            assetQuantity !== 1 ? "ів" : "у"
          } на ваш вибір. Оплата здійснюється щомісяця.`,
      },
      apply: "Застосувати",
      applyLoading: "Завантаження...",
      promocode: "Є промокод?",
      info: "Промокод надає знижку лише на перший платіж.",
    },
    landing: {
      hero: {
        heading1: "Приймайте розумніші торгові рішення з",
        heading2: "Глибинною аналітикою ринку",
        subheading:
          "Припиніть гадати напрямок ринку. Отримуйте реальні ринкові інсайти для 14 основних активів у реальному часі та торгуйте впевнено.",
        freeStart: "Почати безкоштовно",
        noCard: "Без банківської карти",
        socialProof: "Нам довіряють понад 1 500 трейдерів у всьому світі",
        cta: "Отримати безкоштовний доступ зараз",
        ctaSecondary: "Переглянути 2-хвилинне демо",
      },
      trust: {
        heading: "Чому трейдери довіряють MarketEcho",
        metric1Value: "99.9%",
        metric1Label: "Безперебойної роботи",
        metric2Value: "1 500+",
        metric2Label: "Активних інтрадей-трейдерів",
        metric3Value: "14",
        metric3Label: "Підтримуваних активів",
        metric4Value: "24/5",
        metric4Label: "Оновлення в реальному часі",
        metric5Value: "1M+",
        metric5Label: "Щоденних точок даних",
      },
      testimonials: {
        heading: "Що говорять трейдери",
        testimonial1: {
          quote:
            "Ймовірнісні інсайти MarketEcho повністю змінили мою торгову стратегію. Прогнози типів днів надзвичайно точні.",
          author: "Michael Chen",
          role: "Професійний Forex трейдер",
          period: "5 років досвіду",
        },
        testimonial2: {
          quote:
            "Нарешті платформа, яка надає необхідні дані без зайвої складності. Метрики сесій самі по собі варті підписки.",
          author: "Sarah Rodriguez",
          role: "Дейтрейдер",
          period: "3 роки досвіду",
        },
        testimonial3: {
          quote:
            "Спочатку я скептично ставився, але безкоштовний план переконав мене. Зараз я на плані з 5 активами і мій відсоток виграшу значно підвищився.",
          author: "James Davidson",
          role: "Свінг трейдер",
          period: "7 років досвіду",
        },
        testimonial4: {
          quote:
            "Аналітика таймінгу сесій змінила мою стратегію London breakout. Тепер я точно знаю, коли входити у позиції.",
          author: "Emma Thompson",
          role: "Скалпер і дейтрейдер",
          period: "4 роки досвіду",
        },
        testimonial5: {
          quote:
            "Як трейдер на повну зайнятість, точні ймовірнісні дані — ключові. MarketEcho дає мені перевагу для стабільного прибутку щомісяця.",
          author: "Robert Martinez",
          role: "Професійний дейтрейдер",
          period: "10+ років досвіду",
        },
      },
      finalize: {
        heading: "Оплата успішна!",
        info: `Будь ласка, завантажте наш десктоп-додаток, щоб підтвердити підписку, обрати бажані активи та почати досліджувати MarketEcho.`,
      },
      header: {
        home: "Home",
        features: "Функції",
        metrix: "Метрики",
        download: "Завантажити",
        pricing: "Тарифи",
        signUp: "Отримати безкоштовний доступ",
        targetAudience: "Для дейтрейдерів та активних інвесторів",
      },
      howItWorks: {
        heading: "Почніть брати кращі угоди за 3 прості кроки",
        title1: "Зареєструйтесь безкоштовно за 60 секунд",
        description1: `Без банківської карти та прихованих платежів. Введіть свій email і миттєво отримайте доступ до реальних ринкових даних у реальному часі для 3 основних активів. Почніть бачити, які торгові стратегії працюють найкраще — вже зараз.`,
        button1: "Отримати миттєвий безкоштовний доступ",
        stepText1: "100% безкоштовно назавжди",
        title2: "Оберіть свій план (доступний безкоштовний варіант назавжди)",
        description2: `Сподобався безкоштовний план? Залишайте його назавжди. Готові до більшого? Підвищіть рівень підписки і отримайте можливість відстежувати до 14 активів з розширеними моделями Live-даних. Скасування у будь-який момент без запитань.`,
        button2: "Переглянути всі плани та тарифи",
        stepText2: "Гнучкі плани — контроль у ваших руках",
        title3: "Торгуйте впевнено з аналітикою на основі даних",
        description3:
          "Припиніть сумніватися у своїх угодах. Отримуйте прогнози на основі історичних даних, аналітику сесій та прогнози типів днів, на які покладаються професійні трейдери для максимізації прибутку.",
        button3: "Почати торгувати розумніше сьогодні",
        stepText3: "Приєднуйтесь до 1 500+ активних трейдерів",
      },
      features: {
        heading: "Все, що потрібно для професійної торгівлі",
        subheading:
          "Розроблено для трейдерів, які цінують точність, швидкість та практичні інсайти",
        autonomous1: "Не пропускайте жодної можливості",
        autonomous2: "Скоро з’явиться десктоп-додаток",
        autonomousDesc:
          "Отримуйте миттєві сповіщення та запускайте аналітику 24/7 — навіть коли вас немає за робочим столом.",
        optimized1: "Приймайте впевнені рішення",
        optimized2: "Щодня",
        optimizedDesc:
          "Наш потужний Big Data движок аналізує мільйони даних щодня, щоб надавати найбільш точні ймовірності ринку на сьогодні.",
        pairScreener: "Знаходьте найкращі торгові можливості",
        pairScreenerDesc:
          "Миттєво скануйте всі 14 активів, щоб дізнатися, на яких ринках зараз найвищі ймовірнісні сценарії.",
        notifications: "Будьте на крок попереду ринку",
        notificationsDesc:
          "Отримуйте сповіщення в реальному часі, коли з’являються високоякісні торгові сигнали — більше не пропускайте виграшні угоди.",
        assetsSupport: "Торгуйте улюбленими ринками",
        assetsSupportDesc:
          "Forex, індекси, товари та криптовалюта. Усі основні активи в одній потужній платформі.",
        multifunctionalDashboard: "Все в одному місці",
        multifunctionalDashboardDesc:
          "Доступ до всіх торгових даних, аналітики та інсайтів із одного інтуїтивного дашборду.",
        liveFeedStatistics: "Торгівля в реальному часі",
        liveFeedStatisticsDesc:
          "Отримуйте оновлення ймовірностей у режимі Live, які адаптуються до змін ринку протягом дня.",
        detailedDashboard: "Розумійте кожен рух ринку",
        detailedDashboardDesc:
          "Глибокий аналіз сесій, типів днів та ймовірнісних сценаріїв для розумнішої торгівлі.",
      },
      plates: {
        plate1: {
          heading: "Прогнози типів днів",
          text1: `Дізнавайтеся заздалегідь, який тип торгового дня очікувати за допомогою ймовірнісних прогнозів. Ми виділили понад 10 унікальних ситуацій днів.`,
          text2: `Більше не потрібно вгадувати між Trend Days та Reversal Days — бачте точну ймовірність кожного сценарію.`,
          text3: `Наша глибока аналітика розраховує ймовірність кожного типу дня у відсотках, щоб ви могли планувати свою стратегію.`,
          text4: `Крім того, отримуйте миттєві сповіщення, коли рівні максимумів (PDH) та мінімумів (PDL) попереднього дня ось-ось будуть пробиті.`,
          tooltip:
            "Типи днів допомагають зрозуміти поведінку ринку та обрати правильну торгову стратегію для поточних умов.",
        },
        plate2: {
          heading: "Аналітика сесій",
          text1: `Визначайте оптимальний час для входу та виходу під час Азіатської, Лондонської та Нью-Йоркської сесій.`,
          text2: `Отримуйте ймовірнісні прогнози, коли кожна сесія ймовірно досягне свого максимуму або мінімуму.`,
          text3: `Слідкуйте за напрямком сесії, зонами розширення та потенціалом прориву — щоб точно знати, коли торгувати, а коли чекати.`,
          tooltip:
            "Аналітика сесій показує, які торгові години пропонують найкращі можливості на основі історичних ймовірнісних даних.",
        },
        plate3: {
          heading: "Щоденні прогнози руху",
          text1: `Бачте, коли ринок найімовірніше досягне свого денного максимуму або мінімуму, на основі тисяч історичних ситуацій.`,
          text2: `Слідкуйте за розширенням ціни в реальному часі, напрямком руху та потенційними точками розвороту протягом торгового дня.`,
          tooltip:
            "Щоденні прогнози допомагають передбачити основні цінові рухи до їх настання, даючи вам суттєву перевагу.",
        },
        plate4: {
          heading: "Метрики початкового балансу (IB)",
          text1: `Отримуйте ймовірнісні дані для першої години торгів — періоду Initial Balance, який часто задає тон на весь день.`,
          text2: `Отримуйте прогнози проривів IB, зон розширення та ймовірності продовження імпульсу чи розворотів.`,
          tooltip:
            "Initial Balance — це перша година торгів. Професійні трейдери використовують дані IB для прогнозування денного діапазону та напрямку.",
        },
        plate5: {
          heading: "Розширена аналітика сесій",
          text1: `Глибший аналіз Regular Trading Hours (RTH), Time Price Opportunity (TPO) та Opening Range Breakout (ORB).`,
          text2: `Переглядайте ймовірності розширення RTH, розподіли профілів та двосторонні сценарії прориву для підвищення своєї переваги.`,
          tooltip:
            "Ці розширені метрики використовують професійні трейдери для визначення високоякісних торгових сигналів та ефективного управління ризиком.",
        },
      },
      demo: {
        heading: "Перегляньте MarketEcho в дії",
        subheading1:
          "Перегляньте 2-хвилинне демо, щоб побачити, як професійні трейдери використовують MarketEcho для ",
        subheading2:
          "підвищення свого відсотку виграшних угод та торгівлі з упевненістю",
        cta: "Почніть безкоштовний пробний період після перегляду",
      },
      download: `Отримайте доступ до MarketEcho у веб-браузері. Десктоп-додаток наразі в розробці; як тільки він буде доступний, він забезпечить ще швидшу роботу та додаткові функції для професійної торгівлі.`,
      downloadCta: "Завантажити для десктопу",
      downloadComingSoon: "Десктоп-додаток скоро запуститься",
      plans: {
        heading: "Обирайте план, який підходить вашому стилю торгівлі",
        subheading: `Почніть 100% безкоштовно та назавжди. Банківська карта не потрібна. Підвищуйте рівень підписки лише тоді, коли готові отримати більше ринків та розширені функції.`,
        action:
          "Усі PRO-плани включають моделі Live-даних, розширену аналітику та пріоритетну підтримку.",
        riskFree: "Гарантія без ризику",
        riskFreeDesc:
          "Скасовуйте будь-коли. Без запитань. Без прихованих платежів.",
        savingsAnnual: "Зекономте 20% при річній оплаті",
        perDay: "за день",
        monthly: "щомісяця",
        annually: "щорічно",
        savePercent: "Зекономте 20%",
        mostPopular: "Найпопулярніший",
        bestValue: "Найвигідніше",
        button: (assetQuantity: number) =>
          `Почати з ${assetQuantity} актив${
            assetQuantity !== 1 ? "ів" : "у"
          } зараз`,
        value1Asset: "Менше ніж чашка кави на день",
        value5Assets: "Лише $1.83 за актив на день",
        value14Assets: "Всього $0.24 за актив на день",
        free: {
          forever: "БЕЗКОШТОВНО НАЗАВЖДИ",
          heading: "MarketEcho Basic",
          li1: "Відстеження 3 активів",
          li2: "Базова аналітика",
          li3: "Статична модель даних (оновлення щодня)",
          li4: "Без банківської карти",
          start: "Почати безкоштовно",
        },
        pro1: {
          badge: "PRO",
          li1: "1 актив з повним доступом до даних",
          li2: "Розширена аналітика",
          li3: "Оновлення ймовірностей у реальному часі",
          li4: "Пріоритетна підтримка через email та чат",
          li5: "Усі майбутні оновлення включені",
        },
        pro5: {
          badge: "НАЙПОПУЛЯРНІШИЙ",
          li1: "5 активів з повним доступом до даних",
          li2: "Розширена аналітика",
          li3: "Оновлення ймовірностей у реальному часі",
          li4: "Пріоритетна підтримка через email та чат",
          li5: "Усі майбутні оновлення включені",
          li6: "Ідеально для активних трейдерів",
        },
        pro14: {
          badge: "НАЙВИГІДНІШЕ",
          li1: "Всі 14 активів з повним доступом до даних",
          li2: "Розширена аналітика",
          li3: "Оновлення ймовірностей у реальному часі",
          li4: "Пріоритетна підтримка через email та чат",
          li5: "Усі майбутні оновлення включені",
          li6: "Ідеально для професійних трейдерів",
        },
      },
      faq: {
        or: "АБО",
        heading: "Поширені запитання",
        subheading: `Є питання? Ми маємо відповіді. Якщо потрібна додаткова допомога, наша служба підтримки завжди готова допомогти 24/7.`,
        contactHeading: "Ще залишилися питання? Зв’яжіться з нами!",
        contactSubheading:
          "Наша команда зазвичай відповідає протягом 2 годин у робочий час",
        subjectLabel: "Тема",
        subjectPlaceholder: "Чим можемо допомогти?",
        messageLabel: "Повідомлення",
        messagePlaceholder: "Розкажіть детальніше про своє питання...",
        sendMessage: "Надіслати email",
        contactTelegram: "Зв’яжіться з нами в Telegram",
        question1: "Що означає 'Live-дані' і чим вони кращі за статичні дані?",
        answer1: `Live-дані оновлюються кілька разів протягом торгового дня відповідно до змін на ринку, надаючи вам найбільш точні ймовірності саме тоді, коли вони потрібні. Статичні дані оновлюються раз на день і підходять для свінг-трейдерів та планування позицій. Live-дані — це ваш асистент у реальному часі, який адаптується до ринку, щоб ви ніколи не приймали рішення на основі застарілої інформації. Усі платні плани включають Live-дані для максимальної точності.`,
        question2: `Які ринки та активи можна торгувати з MarketEcho?`,
        answer2: `Ми підтримуємо всі основні торгові ринки: валютні пари (EURUSD, GBPUSD, USDJPY, USDCHF, USDCAD, EURJPY), фондові індекси (NAS100, SPX500, DJ30, RTY, GER40), товари (Gold/XAUUSD, Oil/CL) та Індекс Долара (DXY). Користувачі з безкоштовною підпискою можуть відстежувати 3 активи: EURUSD, GER40 та XAUUSD. Платні плани розблоковують повну версію даних для 1–14 активів залежно від вашої підписки. Ми постійно додаємо нові активи за запитом трейдерів.`,
        question3: `Чи справді безкоштовний план безкоштовний назавжди? В чому підвох?`,
        answer3: `Так, 100% безкоштовно назавжди. Без банківської карти. Без закінчення пробного періоду. Жодних несподіваних платежів. Ви отримуєте 3 активи, базову аналітику та щодня оновлювані дані назавжди. Ми віримо в те, щоб ви самостійно обрали підвищення рівня підписки, а не нав’язували його. Спробуйте безкоштовний план, оцініть результати, а потім підвищуйте рівень підписки, коли готові до нових ринків та Live-даних. Понад 1 500 трейдерів нам довіряють — багато з них почали саме з безкоштовного плану.`,
        question4: `Скільки коштує MarketEcho і чи можна скасовувати будь-коли?`,
        answer4: `Плани починаються всього від $29.99/місяць (менше $1/день) за 1 актив з Live-даними. Наш найпопулярніший план — 5 активів за $54.99/місяць. Професійні трейдери обирають план на 14 активів за $99.99/місяць — це лише $0.24 за актив на день. Усі плани включають розширену аналітику, оновлення Live-даних та пріоритетну підтримку. Скасовуйте будь-коли без жодних зусиль — жодних довгострокових зобов’язань та запитань.`,
        question5: `Чи можна використовувати MarketEcho на мобільному, чи потрібен десктоп?`,
        answer5: `Ви можете отримати доступ до MarketEcho через будь-який веб-браузер на комп’ютері вже зараз. Ми розробляємо спеціальні десктоп-додатки для ще швидшої роботи та додаткових функцій. Мобільні додатки також плануються. Ви отримаєте сповіщення, як тільки вони будуть доступні.`,
        question6: `Чи безпечна моя платіжна інформація? Як ви обробляєте платежі?`,
        answer6: `Абсолютно безпечно. Ми приймаємо криптоплатежі (TRC20, будь-який криптоактив) та банківські перекази. Ми ніколи не зберігаємо ваші платіжні дані на наших серверах. Всі транзакції обробляються через зашифровані та безпечні канали. Конфіденційність та безпека ваших даних — наш головний пріоритет.`,
        question7: `Що якщо MarketEcho не підходить для мого стилю торгівлі?`,
        answer7: `Почніть з безкоштовного плану, щоб спробувати без ризику. Якщо ви підвищите рівень підписки і зрозумієте, що це не для вас, просто скасуйте — без штрафів та запитань. Ми впевнені, що ви побачите цінність уже через кілька днів використання наших ймовірнісних прогнозів. Приєднуйтесь до 1 500+ трейдерів, які підвищили свій відсоток виграшних угод з MarketEcho.`,
        question8: `Наскільки точні ваші прогнози та ймовірнісні оцінки?`,
        answer8: `Наше потужне Big Data ядро аналізує мільйони історичних даних для генерації ймовірностей на основі глибокого аналізу ринкових ситуацій. Ми не передбачаємо майбутнє — ми показуємо, що найімовірніше станеться на основі тисяч подібних ринкових сценаріїв. Професійні трейдери використовують ці ймовірності для обґрунтованих рішень, а не для вгадувань. Переконайтеся самі за допомогою безкоштовного плану.`,
      },
      footer: {
        privacy: "Політика конфіденційності",
        terms: "Умови використання",
        disclaimer: "Відмова від відповідальності",
        cookie: "Політика щодо cookies",
        discord: "Приєднатися до нас у Discord",
      },
    },
  },

  en: {
    smallSubscriptionBlock: {
      asset: (assetQuantity: number) =>
        `asset${assetQuantity === 1 ? "" : "s"}`,
    },
    chooseSubscription: {
      heading: "Choose Your Subscription Plan",
      subheading:
        "Leave the market analysis to us so you can make informed decisions.",

      yearly: "Yearly",
      monthly: "Monthly",
      pay: "Proceed to Payment",
      block: {
        info: (assetQuantity: number) =>
          `Live statistics for ${assetQuantity} asset${
            assetQuantity !== 1 ? "s" : ""
          } of your choice. Payment is made monthly.`,
      },
      apply: "Apply",
      applyLoading: "Loading...",
      promocode: "Have a promo code?",
      info: "Promo code provides a discount only on the first payment.",
    },
    landing: {
      hero: {
        heading1: "Make Smarter Trading Decisions with",
        heading2: "Deep-Level Market Analytics",
        subheading:
          "Stop guessing market direction. Get real-time probability-based insights for 14 major assets and trade with confidence.",
        freeStart: "Free to start",
        noCard: "No credit card required",
        socialProof: "Trusted by 1,500+ traders worldwide",
        cta: "Get Free Access Now",
        ctaSecondary: "Watch 2-Min Demo",
      },
      trust: {
        heading: "Why Traders Trust MarketEcho",
        metric1Value: "99.9%",
        metric1Label: "Uptime",
        metric2Value: "1,500+",
        metric2Label: "Active Traders",
        metric3Value: "14",
        metric3Label: "Supported Assets",
        metric4Value: "24/5",
        metric4Label: "Real-Time Updates",
        metric5Value: "1M+",
        metric5Label: "Data Points Daily",
      },
      testimonials: {
        heading: "What Traders Say",
        testimonial1: {
          quote:
            "MarketEcho's probability-based insights have completely transformed my trading strategy. The day type predictions are incredibly accurate.",
          author: "Michael Chen",
          role: "Professional Forex Trader",
          period: "5 years experience",
        },
        testimonial2: {
          quote:
            "Finally, a platform that gives me the data I need without overwhelming complexity. The session metrics alone are worth the subscription.",
          author: "Sarah Rodriguez",
          role: "Day Trader",
          period: "3 years experience",
        },
        testimonial3: {
          quote:
            "I was skeptical at first, but the free plan convinced me. Now I'm on the 5-asset plan and my win rate has improved significantly.",
          author: "James Davidson",
          role: "Swing Trader",
          period: "7 years experience",
        },
        testimonial4: {
          quote:
            "The session timing analytics have been a game-changer for my London breakout strategy. I now know exactly when to enter positions.",
          author: "Emma Thompson",
          role: "Scalper & Day Trader",
          period: "4 years experience",
        },
        testimonial5: {
          quote:
            "As a full-time trader, having accurate probability data is crucial. MarketEcho gives me the edge I need to stay profitable month after month.",
          author: "Robert Martinez",
          role: "Professional Day Trader",
          period: "10+ years experience",
        },
      },
      finalize: {
        heading: "Payment Successful!",
        info: `Please download our desktop app to confirm your subscription, select your desired assets, and start exploring MarketEcho.`,
      },
      header: {
        home: "Home",
        features: "Features",
        metrix: "Metrics",
        download: "Download",
        pricing: "Pricing",
        signUp: "Get Free Access",
        targetAudience: "Built for Day Traders & Active Investors",
      },
      howItWorks: {
        heading: "Start Making Better Trades in 3 Simple Steps",
        title1: "Sign Up Free in 60 Seconds",
        description1: `No credit card required. No hidden fees. Just enter your email and instantly access real-time market probability data for 3 major assets. Start seeing which trading patterns work best—right now.`,
        button1: "Get Instant Free Access",
        stepText1: "100% Free Forever",
        title2: "Choose Your Plan (Free Forever Option Available)",
        description2: `Love the free plan? Keep it forever. Ready for more? Upgrade to track up to 14 assets with advanced Live data models. Cancel anytime. No questions asked.`,
        button2: "See All Plans & Pricing",
        stepText2: "Flexible Plans - You're in Control",
        title3: "Trade with Confidence Using Data-Driven Insights",
        description3:
          "Stop second-guessing your trades. Get probability-based forecasts, session analytics, and day-type predictions that professional traders rely on to maximize profits.",
        button3: "Start Trading Smarter Today",
        stepText3: "Join 1,500+ Successful Traders",
      },
      features: {
        heading: "Everything You Need to Trade Like a Pro",
        subheading:
          "Built for traders who demand accuracy, speed, and actionable insights",
        autonomous1: "Never Miss an Opportunity",
        autonomous2: "Desktop App Coming Soon",
        autonomousDesc:
          "Get instant alerts and run analytics 24/7—even when you're away from your desk.",
        optimized1: "Make Confident Decisions",
        optimized2: "Every Single Day",
        optimizedDesc:
          "Our advanced big data engine analyzes millions of data points daily to give you today's most accurate market probabilities.",
        pairScreener: "Find the Best Trading Opportunities",
        pairScreenerDesc:
          "Scan all 14 assets instantly to discover which markets have the highest probability setups right now.",
        notifications: "Stay Ahead of the Market",
        notificationsDesc:
          "Get real-time alerts when high-probability setups emerge—never miss a winning trade again.",
        assetsSupport: "Trade Your Favorite Markets",
        assetsSupportDesc:
          "Forex, indices, commodities, and crypto. All major assets in one powerful platform.",
        multifunctionalDashboard: "Everything in One Place",
        multifunctionalDashboardDesc:
          "Access all your trading data, analytics, and insights from a single, intuitive dashboard.",
        liveFeedStatistics: "Trade in Real-Time",
        liveFeedStatisticsDesc:
          "Get live probability updates that adapt as market conditions change throughout the day.",
        detailedDashboard: "Understand Every Market Move",
        detailedDashboardDesc:
          "Deep-dive into session analytics, day types, and probability breakdowns for smarter trading.",
      },
      plates: {
        plate1: {
          heading: "Day Type Predictions",
          text1: `Know in advance what type of trading day to expect with probability-based forecasts. We've identified 10+ distinct day patterns.`,
          text2: `No more guessing between Trend Days and Reversal Days—see the exact probability of each scenario.`,
          text3: `Our deep-level analytics calculate the likelihood of every day type in clear percentages, so you can plan your strategy accordingly.`,
          text4: `Plus, get instant alerts when previous day highs (PDH) and lows (PDL) are about to break.`,
          tooltip:
            "Day types help you understand market behavior patterns and choose the right trading strategy for today's conditions.",
        },
        plate2: {
          heading: "Session Analytics",
          text1: `Discover the optimal timing for entries and exits during Asian, London, and New York trading sessions.`,
          text2: `Get probability-based forecasts for when each session is likely to hit its high or low point.`,
          text3: `Track session direction, expansion ranges, and breakout potential—so you know exactly when to trade and when to wait.`,
          tooltip:
            "Session analytics show you which trading hours offer the best opportunities based on historical probability data.",
        },
        plate3: {
          heading: "Daily Movement Forecasts",
          text1: `See when the market is most likely to reach its daily high or low, based on thousands of historical patterns.`,
          text2: `Monitor real-time price expansion, movement direction, and potential reversal points throughout the trading day.`,
          tooltip:
            "Daily forecasts help you anticipate major price movements before they happen, giving you a significant edge.",
        },
        plate4: {
          heading: "Initial Balance (IB) Metrics",
          text1: `Access probability data for the first hour of trading—the Initial Balance period that often sets the tone for the entire day.`,
          text2: `Get forecasts for IB breakouts, expansion ranges, and the likelihood of continued momentum vs. reversals.`,
          tooltip:
            "The Initial Balance is the first hour of trading. Professional traders use IB data to predict the day's range and direction.",
        },
        plate5: {
          heading: "Advanced Session Metrics",
          text1: `Dive deeper with Regular Trading Hours (RTH), Time Price Opportunity (TPO), and Opening Range Breakout (ORB) analytics.`,
          text2: `See RTH expansion probabilities, profile distributions, and two-sided breakout scenarios to refine your edge.`,
          tooltip:
            "These advanced metrics are used by professional traders to identify high-probability setups and manage risk effectively.",
        },
      },
      demo: {
        heading: "See MarketEcho in Action",
        subheading1:
          "Watch this 2-minute demo to see how professional traders use MarketEcho to ",
        subheading2: "increase their win rate and trade with confidence",
        cta: "Start Your Free Trial After Watching",
      },
      download: `Access MarketEcho on web. Desktop application is in development, once it is available it'll give you even faster performance and additional features for professional trading.`,
      downloadCta: "Download for Desktop",
      downloadComingSoon: "Desktop app launching soon",
      plans: {
        heading: "Choose the Plan That Fits Your Trading Style",
        subheading: `Start 100% free, forever. No credit card needed. Upgrade only when you're ready to unlock more markets and advanced features.`,
        action:
          "All PRO plans include Live data models, advanced analytics, and priority support.",
        riskFree: "Risk-Free Guarantee",
        riskFreeDesc: "Cancel anytime. No questions asked. No hidden fees.",
        savingsAnnual: "Save 20% with annual billing",
        perDay: "per day",
        monthly: "monthly",
        annually: "annually",
        savePercent: "Save 20%",
        mostPopular: "Most Popular",
        bestValue: "Best Value",
        button: (assetQuantity: number) =>
          `Start with ${assetQuantity} asset${
            assetQuantity !== 1 ? "s" : ""
          } Now`,
        value1Asset: "Less than a cup of coffee per day",
        value5Assets: "Only $1.83 per asset per day",
        value14Assets: "Just $0.24 per asset per day",
        free: {
          forever: "FREE FOREVER",
          heading: "MarketEcho Basic",
          li1: "3 assets to track",
          li2: "Basic analytics",
          li3: "Static data model (updates daily)",
          li4: "No credit card required",
          start: "Start Free - No Card Needed",
        },
        pro1: {
          badge: "PRO",
          li1: "1 asset with full data access",
          li2: "Advanced analytics",
          li3: "Real-time probability updates",
          li4: "Priority email & chat support",
          li5: "All future updates included",
        },
        pro5: {
          badge: "MOST POPULAR",
          li1: "5 assets with full data access",
          li2: "Advanced analytics",
          li3: "Real-time probability updates",
          li4: "Priority email & chat support",
          li5: "All future updates included",
          li6: "Perfect for active traders",
        },
        pro14: {
          badge: "BEST VALUE",
          li1: "All 14 assets with full data access",
          li2: "Advanced analytics",
          li3: "Real-time probability updates",
          li4: "Priority email & chat support",
          li5: "All future updates included",
          li6: "Perfect for professional traders",
        },
      },
      faq: {
        or: "OR",
        heading: "Frequently Asked Questions",
        subheading: `Got questions? We've got answers. If you need additional help, our support team is here for you 24/7.`,
        contactHeading: "Still Have Questions? Let's Talk!",
        contactSubheading:
          "Our team typically responds within 2 hours during business hours",
        subjectLabel: "Subject",
        subjectPlaceholder: "What can we help you with?",
        messageLabel: "Message",
        messagePlaceholder: "Tell us more about your question...",
        sendMessage: "Send Email",
        contactTelegram: "Contact us on Telegram",
        question1:
          "What does 'Live data' mean and how is it better than Static data?",
        answer1: `Live data updates multiple times throughout the trading day as market conditions change, giving you the most accurate probabilities right when you need them. Static data updates once daily and is perfect for swing traders and position planning. Think of Live data as your real-time trading assistant—it adapts with the market, so you're never making decisions on outdated information. All paid plans include Live data for maximum accuracy.`,
        question2: `Which markets and assets can I trade with MarketEcho?`,
        answer2: `We support all major trading markets: Forex pairs (EURUSD, GBPUSD, USDJPY, USDCHF, USDCAD, EURJPY), Stock Indices (NAS100, SPX500, DJ30, RTY, GER40), Commodities (Gold/XAUUSD, Oil/CL), and the Dollar Index (DXY). Free users can track any 3 assets. Paid plans unlock Live data for 1, 5, or all 14 assets depending on your subscription. We're constantly adding new assets based on trader demand.`,
        question3: `Is the free plan really free forever? What's the catch?`,
        answer3: `Yes, 100% free forever. No credit card required. No trials that expire. No surprise charges. You get 3 assets, basic analytics, and daily updated data permanently. We believe in earning your upgrade, not forcing it. Try the free plan, see results, then upgrade only when you're ready for more markets and real-time data. Over 1,500 traders trust us—many started with the free plan.`,
        question4: `How much does MarketEcho cost and can I cancel anytime?`,
        answer4: `Plans start at just $29.99/month (less than $1/day) for 1 asset with Live data. Our most popular plan is 5 assets for $54.99/month. Professional traders love our 14-asset plan at $99.99/month—that's only $0.24 per asset per day. All plans include advanced analytics, Live data updates, and priority support. Cancel anytime with zero hassle—no long-term commitments, no questions asked.`,
        question5: `Can I use MarketEcho on mobile or do I need a desktop?`,
        answer5: `You can access MarketEcho through any web browser on your computer right now. We're developing dedicated desktop apps for even faster performance and additional features. Mobile apps are planned as well. You'll be notified as soon as they're available.`,
        question6: `Is my payment information secure? How do you process payments?`,
        answer6: `Absolutely secure. We accept crypto payments (TRC20, any crypto asset) and bank transfers. We never store your payment information on our servers. All transactions are processed through encrypted, secure channels. Your data privacy and security are our top priorities.`,
        question7: `What if MarketEcho doesn't work for my trading style?`,
        answer7: `Start with our free plan to test it risk-free. If you upgrade and decide it's not for you, simply cancel—no penalties, no questions asked. We're confident you'll see the value within days of using our probability forecasts. Join 1,500+ traders who've improved their win rates with MarketEcho.`,
        question8: `How accurate are your predictions and probability forecasts?`,
        answer8: `Our advanced big data engine analyzes millions of historical data points to generate probabilities based on extensive market pattern analysis. We don't predict the future—we show you what's most likely to happen based on thousands of similar market patterns. Professional traders use these probabilities to make informed decisions, not guesses. See the difference yourself with our free plan.`,
      },
      footer: {
        privacy: "Privacy Policy",
        terms: "Terms and Conditions",
        disclaimer: "Disclaimer",
        cookie: "Cookie Policy",
        discord: "Join us on Discord",
      },
    },
  },
};
